import React from 'react';

import PsychToolPageBase, { PsychToolPageProps } from './PsychToolPageBase';

const PsychSbtiPage: React.FC<PsychToolPageProps> = ({ onBack, onRequireLogin }) => (
  <PsychToolPageBase onBack={onBack} onRequireLogin={onRequireLogin} testId='sbti' />
);

export default PsychSbtiPage;
